<template>
    <el-dialog custom-class="share_dialog" :model-value="show" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-fenxiang"></i></div>
            <h1>{{ info.title }}</h1>
            <h2>{{ info.desc }}</h2>
            <div class="form_item">
                <span class="name">有效期：</span>
                <el-radio-group v-model="expire">
                    <el-radio :label="7">7天</el-radio>
                    <el-radio :label="30">30天</el-radio>
                </el-radio-group>
            </div>
            <div class="btn_box" v-loading="loading">
                <button @click="onShare">复制链接</button>
                <button @click="handleClose">取消</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { Close } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { apiWeeklyShareCreate } from "@/request/api";
import copyText from "@/utils/copyText";
import { ElMessage } from "element-plus";

const props = defineProps({
    show: { type: Boolean, default: false },
});
const emits = defineEmits(["close"]);
const route = useRoute();
const expire = ref(7);
const loading = ref(false);
const info = computed(() => {
    const { path } = route;
    const res = {
        type: "week", // week为周报分享，artcle为文章分享
        title: "分享速报",
        desc: "首页链接分享，请选择有效期",
    };
    if (path === "/details") {
        res.type = "article";
        res.title = "分享文章";
        res.desc = "文章链接分享，请选择有效期";
    }
    return res;
});
// 分享链接
const shareLink = computed(() => {
    let link = window.location.origin + "/#";
    if (info.value.type === "week") {
        link = `${link}/?share=`;
    } else if (info.value.type === "article") {
        const { articleId, tagId1 } = route.query;
        link = `${link}/details?&articleId=${articleId}&tagId1=${tagId1}&isArt=true&share=`;
    }
    return link;
});

// 点击复制链接
async function onShare() {
    loading.value = true;
    try {
        const params = { shareLink: shareLink.value, expire: expire.value };
        if (info.value.type === "article") {
            params.articleId = route.query.articleId;
        }
        const { code, data } = await apiWeeklyShareCreate(params);
        if (code !== "0") return;
        copyText(shareLink.value + data);
        ElMessage.success("复制成功");
        handleClose();
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    expire.value = 7;
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.share_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .form_item {
            display: flex;
            align-items: center;
            padding-top: 16px;
            height: 64px;
            border-bottom: 2px solid #f0f0f0;
            span {
                font-size: 18px;
                &.name {
                    color: #727272;
                    padding-right: 40px;
                }
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
